import React from 'react'
import renderHtml from 'react-render-html'

const EventEntryPopover = ({ schedule }) => {
  const { title, eventTime, marketingLink, isInternalLink } = schedule

  return (
    <div className="event-entry">
      {eventTime && <p className="event-time">{eventTime}</p>}
      {marketingLink ? (
        <a
          href={marketingLink}
          target={!isInternalLink ? '_blank' : '_self'}
          rel="noopener noreferrer"
          className="event-cta-link"
        >
          {renderHtml(title)}
        </a>
      ) : (
        <p className="event-title">{renderHtml(title)}</p>
      )}
    </div>
  )
}

export default EventEntryPopover
